import { supabase } from '../supabaseClient';
import { format } from 'date-fns';

// Classes
export const fetchClasses = async () => {
  const { data, error } = await supabase.from('classes').select('*').order('title');

  if (error) {
    alert(`Error loading classes: ${error.message}`);
    throw error;
  }
  return data;
};
